/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    
    export class ObjectQueryProjection extends BaseEntity implements Wars.Domain.Model.ObjectQueryProjection {

        myObjectQuery: Wars.Domain.Model.ObjectQuery;
        objectQuery_id: string;
        reportDataTreeItem: Wars.Domain.Model.TreeItem;
        reportDataTreeItem_id: string;
        propertyType: Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType;
        projectionType: Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType;
        orderNumerator: number;
        descending: boolean;
        transientReportMapping: Wars.Domain.Model.ReportMapping;
        transientAliasKey: string;
        alias: string;
        reportDataSubTableSystemColumnName: string;
        reportDataSubTableColumnName: string;

        statusHistoryQueryMap = new StatusHistoryQueryMap();
        assignmentQueryMap = new AssignmentQueryMap();
        reviewInformationQueryMap = new ReviewInformationQueryMap();
        commentInformationQueryMap = new CommentInformationQueryMap();
        
        projectionTypeContext = new models.EnumDropDownContext();
        propertyTypeContext = new models.EnumDropDownContext();

        constructor() {
            super();
        }

        getExtendedQueryColumn(): ExtendedQueryColumn {
            var self = this;
            if (self.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                return Enumerable.from(self.assignmentQueryMap.columns)
                    .where(i => i.column === self.reportDataSubTableColumnName)
                    .singleOrDefault();
            }
            if (self.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                return Enumerable.from(self.reviewInformationQueryMap.columns)
                    .where(i => i.column === self.reportDataSubTableColumnName)
                    .singleOrDefault();
            }
            if (self.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                return Enumerable.from(self.statusHistoryQueryMap.columns)
                    .where(i => i.column === self.reportDataSubTableColumnName)
                    .singleOrDefault();
            }
            if (self.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                return Enumerable.from(self.commentInformationQueryMap.columns)
                    .where(i => i.column === self.reportDataSubTableColumnName)
                    .singleOrDefault();
            }
            return null;
        }
    }

}